import React from "react";

import "../assets/styles/help_footer.scss";

/**
 * HelpFooter
 * Sticky help banner that stays at the bottom of the viewport.
 * Exact text: "Need help? Contact Geko Gold support"
 * The highlighted part is a link styled in gold.
 */
const HelpFooter = ({
  href = "#",
  onLinkClick,
  target = "_blank",
}) => {
  return (
    <footer className="help-footer" role="contentinfo" aria-label="Help footer">
      <div className="help-footer__container">
        <span className="help-footer__text">Need help? Contact</span>
        {/* Non-breaking space to keep spacing consistent with the design */}
        <a
          className="help-footer__link"
          href={href}
          target={target}
          rel={target === "_blank" ? "noopener noreferrer" : undefined}
          onClick={onLinkClick}
        >
          Geko Gold support
        </a>

        <span className="help-footer__text"></span>
      </div>
    </footer>
  );
};

export default HelpFooter;
